export const query_allegato_byTenant = `
query getAllegatiByTenant($tenantId: String!) {
  allegato(where: {TenantId: {_eq: $tenantId}}, order_by: {CreatedOn: desc}) {
    Id
    EntityType
    EntityId
    FileName
    FileType
    FileUrl
    DisplayedName
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
  }
}`; // Tenuto per exportHome, da valutare un refactor di exportHome per evitare di dover mantenere query simili in più posti
export const query_getAllegati = `
query getAllegati($fascicoloId: Int!, $tenantId: String!, $aziendaId: Int!) {
  getAllegati(fascicoloId: $fascicoloId, tenantId: $tenantId, aziendaId: $aziendaId) {
    id
    entityType
    entityId
    fileName
    fileType
    fileUrl
    displayedName
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    signatureHubId
    signatureStatus
    signatureUrl
    signedOn
    signatureExpire
    cctId
    autoSendCCT
  }
}`;
export const query_downloadAllegato = `
query downloadAllegato($allegatoId: Int!, $tenantId: String!, $aziendaId: Int!) {
  downloadAllegato(allegatoId: $allegatoId, tenantId: $tenantId, aziendaId: $aziendaId) {
    id
    entityType
    entityId
    fileName
    fileType
    fileUrl
    displayedName
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    signatureHubId
    signatureStatus
    signatureUrl
    signedOn
    signatureExpire
    fileBase64
  }
}`;